// import axios from "axios";

// const baseApi = "http://agtest.escvpn.com/api/plan/1";

export async function apiInitGet(api) {
  return 0;
}

export async function apiInitPost(api) {
  return 0;
}

export async function apiInitPut(api) {
  return 0;
}

export async function apiInitDelete(api) {
  return 0;
}

export const getCarImage = (v) =>
  "https://testkalyaniadmin.kalyanimotors.com/storage/" + v;

export const getServiceImage = (v) =>
  "https://testkalyaniadmin.kalyanimotors.com/storage/" + v;

export const getImage = (v) =>
  "https://testkalyaniadmin.kalyanimotors.com/storage/" + v;

export const getFile = (v) => "https://testkalyaniadmin.kalyanimotors.com/" + v;
